//@ts-nocheck
import { Box, IconNew, TextInput } from '@jfs/ui-new'
import { useRef } from 'react'
import { colors } from '../../util/colors'
import { styles } from './styles'
import { DropDownBoxInterface } from './types'

export const DropDownBox = ({
  onLayout,
  toggleDropdown,
  defaultLabel,
  dropdownVisible,
  value,
  label,
  placeholder,
}: DropDownBoxInterface) => {
  const boxRef = useRef(null)
  const handlePress = (evt: any) => {
    toggleDropdown(true)
    onLayout &&
      onLayout({
        left: evt.nativeEvent.pageX - evt.nativeEvent.layerX,
        top: evt.nativeEvent.pageY - evt.nativeEvent.layerY,
        width: boxRef?.current?.offsetWidth,
      })
  }
  return (
    <Box>
      <Box {...styles.overlayStyle} onPress={handlePress} />
      <Box {...styles.labelContainer} flexDirection="row">
        <TextInput
          innerRef={boxRef}
          editable={false}
          label={label}
          value={value}
          placeholder={placeholder}
          fontSize={14}
        />
        <Box {...styles.dropdownIconContainer} onPress={() => toggleDropdown()}>
          <IconNew id={dropdownVisible ? 'ARROW_UP' : 'ARROW_DOWN'} size={22} color={colors.JIO_PRIMARY_ALPHA} />
        </Box>
      </Box>
    </Box>
  )
}
